import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import Cookies from 'js-cookie';
import Select from 'react-select';
import setDayjsLocale from '../utils/setDayjsLocale';
import { selectLanguageStyles } from './shared/styles';

const LanguageSwitcher = () => {
  const locales = ['en', 'sv', 'nb', 'es'];
  const { i18n } = useTranslation();

  const localeOptions = locales.map((locale) => ({ value: locale, label: locale }));

  const changeLanguage = (selectedOption) => {
    const lang = selectedOption?.value;
    i18n.changeLanguage(lang);
    Cookies.set('locale', lang);
    setDayjsLocale(lang); 
  };

  useEffect(() => {
    const savedLocale = Cookies.get('locale') || i18n.language;
    i18n.changeLanguage(savedLocale); 
    setDayjsLocale(savedLocale); 
  }, [i18n]);

  return (
    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: 20}}>
      <Select
        options={localeOptions}
        value={localeOptions.find((locale) => locale.value === i18n.language)}
        onChange={changeLanguage}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.value}
        styles={selectLanguageStyles }
      />
    </div>
  );
};

export default LanguageSwitcher;
